import { X } from "lucide-react";

interface ProfileImageUploadProps {
  userData: any;
  user: any;
  isEditMode: boolean;
  newProfileImage: File | null;
  fileError: string;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onPhotoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemovePhoto: () => void;
}

export default function ProfileImageUpload({
  userData,
  user,
  isEditMode,
  newProfileImage,
  fileError,
  fileInputRef,
  onPhotoChange,
  onRemovePhoto,
}: ProfileImageUploadProps) {
  return (
    <div
      className={`w-full sm:w-32 ${isEditMode ? "flex flex-col items-center gap-2" : "flex items-center justify-center min-h-full"}`}
    >
      <div
        className={`h-20 w-20 sm:h-24 sm:w-24 rounded-full overflow-hidden bg-white border-2 border-gray-100 flex items-center justify-center ${!isEditMode ? "mx-auto" : ""}`}
      >
        {userData.roleSpecificData?.picture ||
        userData.auth0Profile?.picture ||
        user.picture ? (
          <img
            src={
              userData.roleSpecificData?.picture ||
              userData.auth0Profile?.picture ||
              user.picture
            }
            alt={
              userData.auth0Profile?.name ||
              userData.auth0Profile?.nickname ||
              "Avatar"
            }
            className="w-full h-full object-cover bg-white"
            onLoad={() => {
              // Image loaded successfully
            }}
            onError={() => {
              // Handle image load error if needed
            }}
          />
        ) : (
          <span className="text-xl sm:text-2xl font-semibold text-white">
            {userData.auth0Profile?.nickname?.[0]?.toUpperCase() ||
              userData.auth0Profile?.email?.[0]?.toUpperCase() ||
              "U"}
            {userData.auth0Profile?.nickname
              ?.split(".")[1]?.[0]
              ?.toUpperCase() || ""}
          </span>
        )}
      </div>
      <input
        type="file"
        accept="image/jpeg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp"
        className="hidden"
        ref={fileInputRef}
        onChange={onPhotoChange}
      />
      {isEditMode && (
        <div className="min-h-[40px] flex flex-col items-center mt-2 w-full sm:w-auto">
          {!newProfileImage ? (
            <button
              onClick={() => fileInputRef.current?.click()}
              className="px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md hover:bg-gray-50 transition-colors w-full sm:w-auto max-w-[140px]"
            >
              Cambiar foto
            </button>
          ) : (
            <div className="flex flex-col items-center gap-1 w-full sm:w-auto">
              <div
                className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-md max-w-full ${
                  fileError
                    ? "bg-red-100 text-red-800"
                    : "bg-blue-100 text-blue-800"
                }`}
              >
                <span className="truncate max-w-[100px] sm:max-w-[120px]">
                  {newProfileImage.name}
                </span>
                <button
                  type="button"
                  onClick={onRemovePhoto}
                  className={`rounded-full p-0.5 flex-shrink-0 ${
                    fileError ? "hover:bg-red-200" : "hover:bg-blue-200"
                  }`}
                >
                  <X className="w-3 h-3" />
                </button>
              </div>
              {fileError && (
                <p className="text-xs text-red-600 text-center max-w-full leading-tight px-2">
                  {fileError}
                </p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
